import {
  AIServiceSpeechRealtimeApi,
  RealtimeMessageResult,
} from "../../../libs/oci-aispeech-realtime-web";
import { ITranscriptionService } from "../interfaces/ITranscriptionService";
import { RealtimeParametersModelDomainEnum } from "../../../libs/oci-aispeech-realtime-web";
import { RealtimeParametersStabilizePartialResultsEnum } from "../../../libs/oci-aispeech-realtime-web";
import EventEmitter from "../../../shared/EventEmitter";

interface IOracleTranscriptionAdapterConfig {
  language: string;
  token: string;
  compartmentId: string;
  region: string;
}

export class OracleTranscriptionAdapter
  extends EventEmitter
  implements ITranscriptionService
{
  //
  private recognizer: AIServiceSpeechRealtimeApi | null;
  private token: string;
  private compartmentId: string;
  private region: string;
  private language: string;
  private mediaStream: MediaStream | null = null;

  constructor(config: IOracleTranscriptionAdapterConfig) {
    super();
    this.recognizer = null;
    this.token = config.token;
    this.compartmentId = config.compartmentId;
    this.region = config.region;
    this.language = config.language;
  }

  startTranscription(mediaStream: MediaStream) {
    if (!mediaStream) {
      throw new Error("No mediaStream was received.");
    }
    this.mediaStream = mediaStream;

    const serviceRegion = this.region;
    const realtimeParameters = {
      languageCode: this.language,
      modelDomain: RealtimeParametersModelDomainEnum.GENERIC,
      stabilizePartialResults:
        RealtimeParametersStabilizePartialResultsEnum.NONE,
      partialSilenceThresholdInMs: 0,
      finalSilenceThresholdInMs: 1000,
      shouldIgnoreInvalidCustomizations: false,
      encoding: "audio/raw;rate=16000",
    };

    const realtimeEventListener = {
      onResult: (resultMessage: RealtimeMessageResult) => {
        const transcription = resultMessage.transcriptions[0];
        if (transcription.isFinal) {
          this.emit("recognized", transcription.transcription);
        } else {
          this.emit("recognizing", transcription.transcription);
        }
      },
      onError: (error: any) => {
        this.emit("error", error);
      },
      onClose: () => {
        this.emit("stopped");
      },
      onConnect: () => {
        this.emit("connected");
      },
    };

    this.recognizer = new AIServiceSpeechRealtimeApi(
      //@ts-ignore
      realtimeEventListener,
      this.token,
      this.compartmentId,
      this.mediaStream,
      `wss://realtime.aiservice.${serviceRegion}.oci.oraclecloud.com/ws/transcribe/stream`,
      realtimeParameters
    );

    this.recognizer.connect();
  }

  pauseTranscription() {
    this.recognizer?.pause();
  }

  resumeTranscription() {
    this.recognizer?.resume();
  }

  async stopTranscription() {
    if (this.recognizer) {
      this.recognizer.close();
      this.emit("stopped");
    }
  }
}
